import { createReducer } from 'redux-create-reducer';
import {
  fetchContactsAction,
  fetchContactsSuccessAction,
  addContactAction,
} from '../actions/contacts';

const initialState = {
  choice: [],
  isFetching: false,
};

export const contactReducer = createReducer(initialState, {
  [fetchContactsAction]: state => {
    return {
      ...state,
      isFetching: true,
    };
  },
  [fetchContactsSuccessAction]: (state, action) => {
    return {
      ...state,
      choice: action.payload,
      isFetching: false,
    };
  },
  [addContactAction]: (state, action) => {
    const choice = state.choice.slice();
    choice.push(action.payload);
    return {
      ...state,
      isFetching: false,
      choice: choice,
    };
  },
});

export default contactReducer;

export const getContacts = state => state.contacts.choice;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step1/reducers/contacts.js